import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "./http.service";

/**
 * Service for account operations
 *
 * @author jbruenker
 */
@Injectable({ providedIn: 'root' })
export class AccountService {
  constructor(private httpService: HttpService) {}

  private readonly ACCOUNT_ENDPOINT = '/account'

  getFullName = (user: string): Observable<string> =>
    this.httpService.getString(`${this.ACCOUNT_ENDPOINT}/full-name/${user}`);
}
